/* eslint-disable max-len */
import React from 'react';
import NewExportIcon from '../../svgs/NewExportIcon';
import ExportPDF from '../ExportPDF';
import FilterPeriod from '../FilterPeroid';
import SearchBox from '../SearchBox';
// import NewFilterComponents from '../NewFilterComponent';
// import StyledButton from '../StyledButton';
import Styles from './DashboardHeaderWithFilters.module.scss';

interface IDashboardHeaderWithFilters{
  title?:string;
  filterObj?: any;
  dateType?:string;
  isThisWeek?:boolean;
  exportObj?:any;
  hideTitle?:boolean;
  hideFilter?:boolean;
  setDateLabel?:any;
  searchPlaceholder?: string;
  search?: string;
  onSearchChange?:any;
  disableSearch?:boolean;
  showSearch?:boolean;
}

type IFilterDate = {
  from?: string;
  to?: string;
  setFrom?: any;
  setTo?: any;

}

type IFilterProps = IFilterDate
const DashboardHeaderWithFilters = ({
  title, filterObj, dateType, isThisWeek, exportObj, hideTitle, hideFilter, setDateLabel, searchPlaceholder, search, onSearchChange, disableSearch, showSearch,
}:IDashboardHeaderWithFilters) => {
  const renderComponents = (
    type: string,
    dataCompProps: IFilterProps,
    index,
    caseType?:string,
  ) => {
    switch (type) {
    case `${caseType || 'dateRange'}`:
      return (
        <FilterPeriod {...dataCompProps} key={index} filterObj={filterObj} type={dateType} isThisWeek={isThisWeek} setDateLabel={setDateLabel} />
      );
    default:
      return <div />;
    }
  };
  return (
    <div className={Styles.wrapper}>
      <div className={Styles.wrapper__titleAndFilter}>
        {
          !hideTitle && <div className={Styles.wrapper__title}>{title}</div>
        }

        {
          !hideFilter && (
          <div>
            {
              filterObj?.filters?.map(
                ({
                  type,
                  ...props
                }: IFilterProps & {type: string}, index) => renderComponents(type, props, index, dateType),
              )
            }
          </div>
          )
        }

        {
          exportObj && (
          <div className={Styles.wrapper__btns}>
            <ExportPDF exportObj={exportObj} name="Export" boxShadow="0px 0px 10px 0px #20202014" padding="10px 8px" icon={<NewExportIcon />} />
          </div>
          )
        }
      </div>
      {
        showSearch && (
        <div className={Styles.wrapper__searchContainer}>
          <span className={Styles.wrapper__searchTag}>Search here</span>
          <SearchBox disabled={disableSearch} loading={false} name="search" placeholder={searchPlaceholder} value={search} handleChange={onSearchChange || (() => {})} />
        </div>
        )
      }

      {/* <NewFilterComponents
        // className={`${'' ? '' : 'filters-hidden'}`}
        filterObj={filterObj}
        // onClose={() => console.log('close')}
      /> */}
    </div>
  );
};

export default DashboardHeaderWithFilters;
